import { connect } from 'react-redux';
import _ from 'lodash';
import SlackChannels from '../components/slack_channels/slack_channels';
import {
  updateSlackBlacklist,
  addToSlackBlacklist,
  removeFromSlackBlacklist,
} from '../actions/slack';

function mapStateToProps({ slack }) {
  const { team, channels } = slack;
  return {
    team,
    channels: _.values(channels),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateBlacklist: ({ removeIds, addIds }) => (
      dispatch(updateSlackBlacklist({ removeIds, addIds }))
    ),
    addToBlacklist: channelId => (dispatch(addToSlackBlacklist(channelId))),
    removeFromBlacklist: channelId => (dispatch(removeFromSlackBlacklist(channelId))),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SlackChannels);



// WEBPACK FOOTER //
// ./src/containers/slack_channels.js